import { ColumnDefinition } from '../types/excel.types';

export const COLUMNS: Record<string, ColumnDefinition> = {
   // Item columns
   itemNumber: {
      header: 'Item Number',
      group: 'item',
      tableId: 'itemNo',
      numeric: false,
   },
   hfb: {
      header: 'HFB',
      group: 'item',
      tableId: 'hfb',
      numeric: false,
   },
   pa: {
      header: 'PA',
      group: 'item',
      tableId: 'pa',
      numeric: false,
   },
   buCodePru: {
      header: 'PRU',
      group: 'item',
      tableId: 'buCodePru',
      numeric: false,
   },
   buCodePdu: {
      header: 'PDU',
      group: 'item',
      tableId: 'buCodePdu',
      numeric: false,
   },
   familyName: {
      header: 'Family Name',
      group: 'item',
      tableId: 'familyName',
      numeric: false,
   },
   itemName: {
      header: 'Item Name',
      group: 'item',
      tableId: 'itemName',
      numeric: false,
   },
   itemState: {
      header: 'Item State',
      group: 'item',
      tableId: 'itemState',
      numeric: false,
   },
   saleStartDateGlobal: {
      header: 'Sale Start Date Global',
      group: 'item',
      tableId: 'saleStartDateGlobal',
      numeric: false,
   },
   saleEndDateGlobal: {
      header: 'Sale End Date Global',
      group: 'item',
      tableId: 'saleEndDateGlobal',
      numeric: false,
   },
   cpNetWeight: {
      header: 'Net Weight (g)',
      group: 'item',
      tableId: 'cpNetWeight',
      numeric: true,
      format: '0.00',
   },
   partsWeight: {
      header: 'Weight of Mapped Parts (g)',
      group: 'item',
      tableId: 'partsWeight',
      numeric: true,
      format: '0.00',
   },
   partsEmission: {
      header: 'CO₂-e of mapped parts (g)',
      group: 'item',
      tableId: 'partsEmission',
      numeric: true,
      format: '0.00',
   },
   dwpDeviation: {
      header: 'DWP Deviation (%)',
      group: 'item',
      tableId: 'dwpDeviation',
      numeric: true,
      format: '0.00',
   },
   isBase: {
      header: 'Is Base',
      group: 'item',
      tableId: 'isBase',
      numeric: false,
   },
   parentItemNo: {
      header: 'Base Item No.',
      group: 'item',
      tableId: 'parentItemNo',
      numeric: false,
   },

   // Subitem columns
   id: {
      header: 'Unique ID',
      group: 'subitem',
      tableId: 'id',
      numeric: true,
   },
   partDetail: {
      header: 'Part Detail',
      group: 'subitem',
      tableId: 'partDetail',
      numeric: false,
   },
   part: {
      header: 'Part',
      group: 'subitem',
      tableId: 'part',
      numeric: false,
   },
   materialGradeId: {
      header: 'MAM - Material Grade ID',
      group: 'subitem',
      tableId: 'materialGradeId',
      numeric: false,
   },
   materialGrade: {
      header: 'Material Grade',
      group: 'subitem',
      tableId: 'materialGrade',
      numeric: false,
   },
   materialCategoryId: {
      header: 'Material Category ID',
      group: 'subitem',
      tableId: 'materialCategoryId',
      numeric: false,
   },
   materialTypeId: {
      header: 'Material Type ID',
      group: 'subitem',
      tableId: 'materialTypeId',
      numeric: false,
   },
   materialSubtypeId: {
      header: 'Material Subtype ID',
      group: 'subitem',
      tableId: 'materialSubtypeId',
      numeric: false,
   },
   compositionShare: {
      header: 'Composition Share (%)',
      group: 'subitem',
      tableId: 'compositionShare',
      numeric: true,
      format: '0.00%',
   },
   matSetName: {
      header: 'Material set name',
      group: 'subitem',
      tableId: 'matSetName',
      numeric: false,
   },
   threeDModelNo: {
      header: '3D Model No.',
      group: 'subitem',
      tableId: 'threeDModelNo',
      numeric: false,
   },
   totalWeight: {
      header: 'Total Weight (g)',
      group: 'subitem',
      tableId: 'totalWeight',
      numeric: true,
      format: '0.00',
   },
   totalEmission: {
      header: 'CO₂-e (g)',
      group: 'subitem',
      tableId: 'totalEmission',
      numeric: true,
      format: '0.00',
   },
   quantity: {
      header: 'Quantity',
      group: 'subitem',
      tableId: 'quantity',
      numeric: false,
   },
   mass: {
      header: 'Mass (g)',
      group: 'subitem',
      tableId: 'mass',
      numeric: true,
      format: '0.00',
   },
   volume: {
      header: 'Volume (mm³)',
      group: 'subitem',
      tableId: 'volume',
      numeric: true,
      format: '0.00',
   },
   density: {
      header: 'Density (kg/m³)',
      group: 'subitem',
      tableId: 'density',
      numeric: true,
      format: '0.00',
   },
   dwpTotalWeight: {
      header: 'DWP Weight (g)',
      group: 'subitem',
      tableId: 'dwpTotalWeight',
      numeric: true,
      format: '0.00',
   },
   recycledContent: {
      header: 'Recycled Content (%)',
      group: 'subitem',
      tableId: 'recycledContent',
      numeric: true,
      format: '0.00%',
   },
   renewableContent: {
      header: 'Renewable Content (%)',
      group: 'subitem',
      tableId: 'renewableContent',
      numeric: true,
      format: '0.00%',
   },
   updatedBy: {
      header: 'Updated By',
      group: 'subitem',
      tableId: 'updatedBy',
      numeric: false,
   },
   updatedAt: {
      header: 'Updated At',
      group: 'subitem',
      tableId: 'updatedAt',
      numeric: false,
   },
   comment: {
      header: 'Comment',
      group: 'subitem',
      tableId: 'comment',
      numeric: false,
   },
   active: {
      header: 'Active',
      group: 'subitem',
      tableId: 'active',
      numeric: false,
   },
};

export const COLUMN_GROUPS = {
   item: [
      'itemNumber',
      'hfb',
      'pa',
      'buCodePru',
      'buCodePdu',
      'familyName',
      'itemName',
      'itemState',
      'saleStartDateGlobal',
      'saleEndDateGlobal',
      'cpNetWeight',
      'partsWeight',
      'partsEmission',
      'dwpDeviation',
      'isBase',
      'parentItemNo',
   ],
   subitem: [
      'id',
      'partDetail',
      'part',
      'materialGradeId',
      'materialGrade',
      'materialCategoryId',
      'materialTypeId',
      'materialSubtypeId',
      'compositionShare',
      'matSetName',
      'threeDModelNo',
      'totalWeight',
      'totalEmission',
      'quantity',
      'mass',
      'volume',
      'density',
      'dwpTotalWeight',
      'recycledContent',
      'renewableContent',
      'updatedBy',
      'updatedAt',
      'comment',
      'active',
   ],
};

export const ALL_EXPORT_COLUMNS = [...COLUMN_GROUPS.item, ...COLUMN_GROUPS.subitem];

export const getTableColumnId = (exportColumnId: string): string => {
   return COLUMNS[exportColumnId]?.tableId || exportColumnId;
};
